<div *ngIf="control && control.errors && control.touched" id="dataErrors">
  <div *ngFor="let entry of control.errors | keys" class="dataError">
    {{ 'validation.errors.' + entry | translate }}
  </div>
</div>
